import styles from './Question.module.css';
import { AnimatePresence, motion } from 'motion/react';
import { useEffect, useState } from 'react';

export const Question = ({ title }) => {
  const titleArr = title?.split(/\r?\n/);

  const letters = titleArr[0]?.split('');

  const [firstLine, setFirstLine] = useState(true);

  useEffect(() => {
    let idTimeout = '';

    idTimeout = setTimeout(() => {
      setFirstLine(false);
    }, 4000);

    return () => {
      clearTimeout(idTimeout);
    };
  }, []);

  return (
    <div className={styles.questionBlock}>
      <AnimatePresence>
        {titleArr[0] && firstLine && (
          <motion.div
            initial={{ scale: 1 }}
            animate={{ scale: [1, 1.35, 1, 1.35] }}
            transition={{
              duration: 1.35,
              delay: 1.8,
              times: [0, 0.35, 0.66, 1],
              ease: ['easeOut', 'easeInOut', 'easeInOut'],
            }}
            className={styles.firstLine}
            dir="rtl"
          >
            {letters &&
              firstLine &&
              Array.isArray(letters) &&
              letters.reverse().map((l, idx, arr) => {
                let initialIdx = 3;
                let oneLetterWidth = 16;
                let initialX = `${(idx - initialIdx) * oneLetterWidth}rem`;

                return (
                  <motion.div
                    style={{ position: 'relative', zIndex: idx * -1 }}
                    key={l + idx}
                    initial={{
                      scale: 0,
                      x: initialX,
                      // textShadow:
                      //   '0 0 2rem #00d8ff00, 0 0 2rem #00d8ff00, 0 0 2rem #00d8ff00',
                    }}
                    animate={{
                      scale: 1,
                      x: 0,
                      // textShadow:
                      //   '0 0 2rem #00d8ffff, 0 0 2rem #00d8ffff, 0 0 2rem #00d8ffff',
                    }}
                    exit={{
                      scale: 0,
                      x: initialX,
                      // textShadow:
                      //   '0 0 2rem #00d8ff00, 0 0 2rem #00d8ff00, 0 0 2rem #00d8ff00',
                      transition: {
                        delay: (arr.length - idx) * 0.15,
                        duration: 0.7,
                      },
                    }}
                    transition={{
                      // textShadow: { duration: 0.6, delay: idx * 0.3 },
                      duration: 0.7,
                      delay: idx * 0.15,
                    }}
                  >
                    {l}
                  </motion.div>
                );
              })}
          </motion.div>
        )}
      </AnimatePresence>

      {titleArr[1] && (
        <motion.div
          initial={{ scale: 20, opacity: 0 }}
          animate={{
            scale: [20, 1, 1.5],
            opacity: 1,
            transition: {
              opacity: { duration: 0.6, delay: 5 },
              scale: {
                duration: 1.75,
                delay: 5,
                times: [0, 0.65, 1],
                ease: ['easeOut', 'easeInOut'],
              },
            },
          }}
          exit={{
            x: '100vw',
            transition: { duration: 0.5, delay: 0 },
          }}
          className={styles.secondLine}
        >
          <div>{titleArr[1]}</div>
        </motion.div>
      )}
      {titleArr[2] && (
        <motion.div
          initial={{ scale: 20.6, opacity: 0 }}
          animate={{
            scale: [20.6, 1, 1.5, 1],
            opacity: 1,
            transition: {
              opacity: { duration: 0.8, delay: 7 },
              scale: {
                duration: 2.15,
                times: [0, 0.59, 0.88, 1],
                ease: ['easeOut', 'easeInOut', 'easeInOut'],
                delay: 7,
              },
            },
          }}
          exit={{
            x: '-100vw',
            transition: { duration: 0.5, delay: 0 },
          }}
          className={styles.thirdLine}
        >
          <div>{titleArr[2]}</div>
        </motion.div>
      )}
      {titleArr[3] && (
        <motion.div
          initial={{ y: '50vh', opacity: 0 }}
          animate={{
            y: '0',
            opacity: 1,
            transition: {
              opacity: { duration: 0.45, delay: 9.43 },
              y: { duration: 0.7, ease: 'easeIn', delay: 9.43 },
            },
          }}
          exit={{
            x: '100vw',
            transition: { duration: 0.5, delay: 0 },
          }}
          className={styles.fourthLine}
        >
          <div>{titleArr[3]}</div>
        </motion.div>
      )}
    </div>
  );
};
